import React, { PureComponent } from "react";
import moment from "moment-timezone";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, intToRGB, hashCode } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";
import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../assets/svg/arrow-down.svg";

HighchartsCustomEvents(Highcharts);
class MomentsOvertimeChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.expandWidget !== this.props.expandWidget ||
            nextProps.showLegend !== this.props.showLegend ||
            nextProps.showGridLines !== this.props.showGridLines
        ) {
            return true;
        }

        return false;
    }
    componentWillUnmount() {
        this.ro.disconnect();
    }

    getOptions = () => {
        // console.log("helllo", this.props.data);
        let self = this;
        let data = this.props.data && JSON.parse(JSON.stringify(this.props.data));
        let comparisionData = this.props.comparisionData && JSON.parse(JSON.stringify(this.props.comparisionData.chartData));

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        // Comparision for Not Present data

        if (comparisionData) {
            let firstdataValue = data[0]?.data;
            let firstcomparisiondataValue = comparisionData && comparisionData[0]?.data;
            let names = [...new Set([...data.map((v) => v.name), ...comparisionData.map((v) => v.name)])];
            let f1;
            let f2;
            for (let name of names) {
                f1 = data.find((v) => v.name === name);
                f2 = comparisionData.find((v) => v.name === name);

                if (!f1) {
                    f2 = JSON.parse(JSON.stringify(f2));
                    f2.data = firstdataValue ? JSON.parse(JSON.stringify(firstdataValue)) : [];
                    f2.value = 0;
                    let arr = [];

                    for (let obj of f2.data) {
                        arr.push({ ...obj, y: 0, momentId: f2.momentId });
                    }
                    f2.data = arr;

                    data.push(JSON.parse(JSON.stringify(f2)));
                } else if (!f2) {
                    f1 = JSON.parse(JSON.stringify(f1));
                    f1.data = firstcomparisiondataValue ? JSON.parse(JSON.stringify(firstcomparisiondataValue)) : [];
                    f1.value = 0;
                    let arr = [];

                    for (let obj of f1.data) {
                        arr.push({ ...obj, y: 0, momentId: f1.momentId });
                    }
                    f1.data = arr;

                    comparisionData.push(JSON.parse(JSON.stringify(f1)));
                }
            }
        }

        //End of Not present data

        if (comparisionData) {
            comparisionData.forEach((d, i) => {
                d.linkedTo = ":previous";
                if (d.color.length <= 7) {
                    d.color = d.color + "55";
                }
            });
        }

        let plotComaprisiondata;
        let arrayCombined = [];

        let plotComaprisiondataCondition = comparisionData && comparisionData[0].data.length >= data[0].data.length;

        if (plotComaprisiondataCondition && data) {
            plotComaprisiondata = JSON.parse(JSON.stringify(data));

            comparisionData.forEach((ele, index) => {
                ele.data.forEach((element, ind) => {
                    if (plotComaprisiondata[index]?.data[ind]) {
                        plotComaprisiondata[index].data[ind].originalX = plotComaprisiondata[index].data[ind].x;
                        plotComaprisiondata[index].data[ind].x = element.x;
                    }
                });
            });
        } else {
            if (comparisionData) {
                plotComaprisiondata = JSON.parse(JSON.stringify(comparisionData));

                this.props.data &&
                    data.forEach((ele, index) => {
                        ele.data.forEach((element, ind) => {
                            if (plotComaprisiondata[index]?.data[ind]) {
                                plotComaprisiondata[index].data[ind].originalX = plotComaprisiondata[index].data[ind].x;
                                plotComaprisiondata[index].data[ind].x = element.x;
                            }
                        });
                    });
            }
        }

        if (comparisionData) {
            data = data.sort((a, b) => {
                if (a.total < b.total) return 1;
                else return -1;
            });
            comparisionData = comparisionData.sort((a, b) => {
                if (a.total < b.total) return 1;
                else return -1;
            });

            plotComaprisiondata = plotComaprisiondata.sort((a, b) => {
                if (a.total < b.total) return 1;
                else return -1;
            });

            plotComaprisiondataCondition
                ? data.forEach((element, ind) => {
                      let comparisionIndex = comparisionData.findIndex((ele) => ele.momentId == element.momentId);
                      let plotComparisionIndex = plotComaprisiondata.findIndex((ele) => ele.momentId == element.momentId);
                      let getName = comparisionData.findIndex((ele) => ele.name == element.name);
                      if (getName > -1) {
                          if (plotComparisionIndex > -1) arrayCombined.push(plotComaprisiondata[plotComparisionIndex]);
                          if (comparisionIndex > -1) arrayCombined.push(comparisionData[comparisionIndex]);
                      }
                  })
                : comparisionData.forEach((element, ind) => {
                      let plotComparisionIndex = plotComaprisiondata.findIndex((ele) => ele.momentId == element.momentId);
                      let dataIndex = data.findIndex((ele) => ele.momentId == element.momentId);
                      let getName = data.findIndex((ele) => ele.name == element.name);

                      if (getName > -1) {
                          if (dataIndex > -1) arrayCombined.push(data[dataIndex]);
                          if (plotComparisionIndex > -1) arrayCombined.push(plotComaprisiondata[plotComparisionIndex]);
                          else arrayCombined.push(data[dataIndex]);
                      }
                  });
        }

        arrayCombined.length > 3 &&
            arrayCombined.map((d, i) => {
                if (d && i > 3) {
                    d.visible = false;
                }
            });

        // console.log("arrayCombined", arrayCombined);

        let serObj = this.props.comparisionData ? arrayCombined : data;

        const chartOptions = {
            chart: {
                type: "spline",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },

            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: plotComaprisiondata ? true : false,
                outside: true,
                crosshairs: true,
                useHTML: true,
                formatter: function () {
                    if (plotComaprisiondata) {
                        let str = "";
                        let ComapareVal1;
                        let ComapareVal2;
                        let dateCompare;
                        let showPercent = true;
                        for (let i = 0; i < this.points.length; i++) {
                            let temp = "";
                            ComapareVal1 = this.points[0].y;
                            ComapareVal2 = this.points[1]?.y;
                            dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                            let firstColorPoint = this.points[1]?.color.endsWith("55");
                            let secondColorPoint = this.points[0]?.color.endsWith("55");

                            if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                                showPercent = false;
                            }

                            temp = `<b>${moment(this.points[i].point.originalX ? this.points[i].point.originalX : this.points[i].x)
                                .tz(tz)
                                .format(
                                    "LLLL",
                                )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                                this.points[i].color
                            };border-radius:10px" ></span>

                            <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                            str += temp;
                        }

                        if (this.points.length == 2 && showPercent) {
                            str += `${
                                ComapareVal1 < ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          dateCompare && "rotate(180deg)"
                                      }" />
                                </div>
                             
                            
                            
                                
                                </div>`
                                    : ComapareVal1 > ComapareVal2
                                    ? `<div> <div style="display:flex;align-item:center"><b>${
                                          ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                                      }</b>
                                   
                                    <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                                          !dateCompare && "rotate(180deg)"
                                      }" />
                                    </div>
                                 
                                
                                
                                    
                                    </div>`
                                    : ""
                            }`;
                        }

                        return str;
                    } else {
                        return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.options?.seriesName}: <b>${numberWithCommas(this.y)}</b>`;
                    }
                },
                backgroundColor: "#fff",
                borderRadius: 6,
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            series: serObj,
            plotOptions: {
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },

                series: {
                    events: {
                        legendItemClick: function () {
                            self.props.legendClick(true);
                        },
                    },
                    marker: {
                        radius: 4,
                        enabled: true,
                        symbol: "circle",
                    },
                },
            },

            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return chartOptions;
    };

    render() {
        return (
            <>
                {this.props.expandWidget ? (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                    />
                ) : (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                    />
                )}
            </>
        );
    }
}

export default MomentsOvertimeChart;
